export { default as historyIntroFiguresPNG } from '~/assets/images/history/history-intro-figures.png'
export { default as historyIntroFiguresWEBP } from '~/assets/images/history/history-intro-figures.webp'

export const INTRO_ACCENT_COLOR = '#8c67f6'
